<template>
  <el-dialog
          :title="!dataForm.id ? '新增' : '修改'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="150px">

      <el-form-item label="合同开始时间" prop="startTime">
        <el-date-picker
                v-model="dataForm.startTime"
                @change="changeDate"
                :picker-options="pickerOptions2"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="合同结束时间" prop="endTime">
        <el-date-picker
                v-model="dataForm.endTime"
                type="date"
                @change="changeDate1"
                :picker-options="pickerOptions3"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="服务地点" prop="workPlace">
        <el-input clearable v-model="dataForm.workPlace" ></el-input>
      </el-form-item>
      <el-form-item label="合同客户" prop="customers">
        <el-select multiple size="large" collapse-tags clearable  filterable  v-model="dataForm.customers" placeholder="请选择客户">
          <el-option v-for="item in customerList" :key="item.id" :label="item.customerName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="合同人数(合同工)" prop="numberWork">-->
<!--        <el-input clearable v-model="dataForm.numberWork"  ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="合同人数(划转工)" prop="numberWorkh">-->
<!--        <el-input clearable v-model="dataForm.numberWorkh"  ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="合同单价(合同工)" prop="price">-->
<!--        <el-input clearable v-model="dataForm.price" ></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="合同单价(划转工)" prop="priceh">-->
<!--        <el-input clearable v-model="dataForm.priceh" ></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="人员配置" prop="">
        <el-form :model="form" ref="form" >
          <el-table :data="form.datils"  border style="width: 100%">

            <el-table-column   label="类型" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'datils.'+scope.$index + '.type'" :rules="rules.type">
                  <el-input  placeholder="类型" size="mini" v-model="scope.row.type" style="width: 100px;"></el-input>
                </el-form-item>
              </template>

            </el-table-column>
            <el-table-column label="人数" width="150">
              <template slot-scope="scope">
                <el-form-item  :prop="'datils.'+scope.$index + '.num'" :rules="rules.num">
                  <el-input  placeholder="数量" size="mini" v-model="scope.row.num" style="width: 100px;"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="单价(元/人)" width="150">
              <template slot-scope="scope">
                <el-form-item  :prop="'datils.'+scope.$index + '.price'" :rules="rules.price">
                  <el-input  placeholder="单价" size="mini" v-model="scope.row.price" style="width: 100px;"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="开始日期" width="250">
              <template slot-scope="scope">
                <el-form-item  :prop="'datils.'+scope.$index + '.startDate'" >
                          <el-date-picker
                                  size="mini"
                                  v-model="scope.row.startDate"
                                  :picker-options="pickerOptions"
                                  value-format="yyyy-MM-dd"
                                  type="date"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                          </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="截止日期" width="250">
              <template slot-scope="scope">
                <el-form-item  :prop="'datils.'+scope.$index + '.endDate'" >
                  <el-date-picker
                          size="mini"
                          v-model="scope.row.endDate"
                          :picker-options="pickerOptions1"
                          value-format="yyyy-MM-dd"
                          type="date"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="operation" fixed="right" >
              <template slot="header" slot-scope="scope">
                <el-button size="mini" @click="click_add( scope.row, scope.$index)">新增</el-button>
              </template>
              <template slot-scope="scope">
                <!--               <el-button size="mini" @click="click_reset(scope.row, scope.$index)">重置</el-button>-->
                <el-button size="mini" @click="click_delete(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-form-item>
      <el-form-item label="已收金额" prop="">
        <el-form :model="ysjeform" ref="ysjeform" >
          <el-table :data="ysjeform.ysjedatils"  border style="width: 100%">

            <el-table-column   label="期初余额金额(元)" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'ysjedatils.'+scope.$index + '.qcyeje'" :rules="ysjerules.qcyeje">
                  <el-input  placeholder="期初余额金额" size="mini" v-model="scope.row.qcyeje" ></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column   label="本期开票金额(元)" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'ysjedatils.'+scope.$index + '.bqkpje'" :rules="ysjerules.bqkpje">
                  <el-input  placeholder="本期开票金额" size="mini" v-model="scope.row.bqkpje" ></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column   label="本期收款金额(元)" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'ysjedatils.'+scope.$index + '.bqskje'" :rules="ysjerules.bqskje">
                  <el-input  placeholder="本期收款金额" size="mini" v-model="scope.row.bqskje" ></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column   label="期末欠款金额(元)" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'ysjedatils.'+scope.$index + '.qmqkje'" :rules="ysjerules.qmqkje">
                  <el-input  placeholder="期末欠款金额" size="mini" v-model="scope.row.qmqkje" ></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column label="收款日期" width="250" >
              <template slot-scope="scope">
                <el-form-item  :prop="'ysjedatils.'+scope.$index + '.skrq'" :rules="ysjerules.skrq">
                          <el-date-picker
                                  size="mini"
                                  v-model="scope.row.skrq"
                                  value-format="yyyy-MM-dd"
                                  type="date">
                          </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="operation" fixed="right">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" @click="click_add_ysje( scope.row, scope.$index)">新增</el-button>
              </template>
              <template slot-scope="scope">
                <!--               <el-button size="mini" @click="click_reset(scope.row, scope.$index)">重置</el-button>-->
                <el-button size="mini" @click="click_delete_ysje(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>

          </el-table>
        </el-form>
      </el-form-item>
      <el-form-item label="合同金额(元)" prop="amount">
        <el-input clearable v-model="dataForm.amount" ></el-input>
      </el-form-item>
      <!-- <el-form-item label="已收金额(元)" prop="amount">
        <el-input clearable v-model="dataForm.receiveAmount" ></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="其他金额(元)" prop="otherAmount">
        <el-input clearable v-model="dataForm.otherAmount" ></el-input>
      </el-form-item> -->
      <el-form-item label="其他金额(元)">
        <el-form :model="qtjeform" ref="qtjeform" >
          <el-table :data="qtjeform.jedatils"  border style="width: 100%">
            <el-table-column  label="金额(元)" width="150">
              <template slot-scope="scope">
                <el-form-item :prop="'jedatils.'+scope.$index + '.je'" :rules="qtjerules.je">
                  <el-input  placeholder="金额" size="mini" v-model="scope.row.je" ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="日期" width="250" >
              <template slot-scope="scope">
                <el-form-item  :prop="'jedatils.'+scope.$index + '.rq'" :rules="qtjerules.rq">
                          <el-date-picker
                                  size="mini"
                                  v-model="scope.row.rq"
                                  value-format="yyyy-MM-dd"
                                  type="date">
                          </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column  label="备注" width="250">
              <template slot-scope="scope">
                <el-form-item :prop="'jedatils.'+scope.$index + '.je'" :rules="qtjerules.bz">
                  <el-input type="textarea" placeholder="备注" size="mini" v-model="scope.row.bz" ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="operation" fixed="right">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" @click="click_add_qtje( scope.row, scope.$index)">新增</el-button>
              </template>
              <template slot-scope="scope">
                <!--               <el-button size="mini" @click="click_reset(scope.row, scope.$index)">重置</el-button>-->
                <el-button size="mini" @click="click_delete_qtje(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>

          </el-table>
        </el-form>
      </el-form-item>
      <el-form-item label="合同文本类型" prop="htwblx">
        <el-select clearable v-model="dataForm.htwblx" placeholder="请选择类型">
          <el-option :key="0" :label="'电子合同'" :value="'电子合同'"></el-option>
          <el-option :key="1" :label="'线下合同'" :value="'线下合同'"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作属性" prop="cooperationStatus">
        <el-select clearable v-model="dataForm.cooperationStatus" placeholder="请选择合作属性">
          <el-option :key="0" :label="'长期合作'" :value="'0'"></el-option>
          <el-option :key="1" :label="'临保合作'" :value="'1'"></el-option>
          <el-option :key="2" :label="'结束合作'" :value="'2'"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属大队" prop="ssdd">
<!--        <el-input clearable v-model="dataForm.ssdd" ></el-input>-->
        <el-select
                clearable
                filterable
                v-model="dataForm.ssdd"
                placeholder="请选择大队"
        >
          <el-option
                  v-for="item in depts"
                  :key="item.bmmc"
                  :label="item.bmmc"
                  :value="item.bmmc"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remaek">
        <el-input type="textarea" v-model="dataForm.remaek" placeholder="备注"></el-input>
      </el-form-item>
      <el-row :gutter="2">
          <el-col :span="12">
            <el-form-item label="附件">
                    <div style="border: 1px solid #c0c4cc; min-height: 70px; width: 100%; height: 200px; background-color: white">
                      <el-upload style="text-align: center;" :on-change="handleChange" :http-request="modeUpload" :auto-upload="false" multiple ref="upload" :show-file-list="false" action="" :file-list="mode">
                        <el-button size="small" type="text">点击上传</el-button>
                    </el-upload>
                      <el-scrollbar class="scrollbar-wrapper" style="height: 168px;overflow-x: hidden;overflow-y: hidden;">
                        <div style="line-height: 28px;" v-for="(item, index) in fileName" :key="index"><i class="el-icon-success" style="color:#67c23a"></i> {{ item.name }} <i style="cursor: pointer" class="el-icon-close" @click="deleteFile(item)"></i></div>                       
                      </el-scrollbar>
                    </div>
                  </el-form-item>
                </el-col>
          <el-col :span="12">
            <el-form-item label="补充协议附件">
              <div style="border: 1px solid #c0c4cc; min-height: 70px; width: 100%; height: 200px; background-color: white">
                      <el-upload style="text-align: center;" :on-change="handleChange2" :http-request="modeUpload" :auto-upload="false" multiple ref="upload2" :show-file-list="false" action="" :file-list="mode">
                        <el-button size="small" type="text">点击上传</el-button>
                    </el-upload>
                      <el-scrollbar class="scrollbar-wrapper" style="height: 168px;overflow-x: hidden;overflow-y: hidden;">
                        <div style="line-height: 28px;" v-for="(item, index) in fileName2" :key="index"><i class="el-icon-success" style="color:#67c23a"></i> {{ item.name }} <i style="cursor: pointer" class="el-icon-close" @click="deleteFile2(item)"></i></div>                       
                      </el-scrollbar>
                    </div>
      </el-form-item>
          </el-col>
        </el-row>
      
      <!-- <el-form-item  prop="attach">
        <el-upload
                action="#"
                :limit="1"
                :on-remove="handleRemove"
                :file-list="fileList"
                :http-request="httpRequest"
                :before-upload="beforeAvatarUpload">
          <el-button size="small" type="primary">{{!dataForm.id ? '点击' : '重新'}}上传</el-button>
        </el-upload>
      </el-form-item> -->
      <!-- <el-upload
                action="#"
                :limit="1"
                :file-list="fileList2"
                :on-remove="handleRemove2"
                :http-request="httpRequest2"
                :before-upload="beforeAvatarUpload"
        ref="upload">
          <el-button size="small" type="primary">{{!dataForm.id ? '点击' : '重新'}}上传</el-button>
        </el-upload> -->
      
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        if(value) {
          var patrn = /^\d+(\.\d+)?$/;
          if (!patrn.exec(value)) {
            callback(new Error('请填写数字'))
          } else {
            callback()
          }
        } else callback()
      }
      return {

        form: {
          datils: [

          ],
          gzlx:'',
        },
        mode: [],
        fileList:[],
        fileName:[],
        fileData:[],
        fileList2:[],
        fileName2:[],
        fileData2:[],
        depts:[],
        ysjeform: {
          ysjedatils: [

          ],
        },
        qtjeform: {
          jedatils: [

          ],
        },
        visible: false,
        menuList: [],
        customerList:[],
        dataForm: {
          id:'',
          numberWork:'',
          numberWorkh:'',
          customers:'',
          startTime:'',
          endTime:'',
          amount:'',
          // receiveAmount:'',
          otherAmount:'',
          ssdd:'',
          attachBc:'',
          price:'',
          priceh:'',
          workPlace:'',
          remaek:'',
          attach:'',
          workConfigs:'',
          receiveAmounts:'',
          qtje:'',
          receiveAmounts:'',
          htwblx: '',
          cooperationStatus: ''
        },
        fileList:[],
        fileList2:[],

        uploadUrl:'',
        dataRule: {
          startTime: [
            {required: true, message: '开始时间不能为空', trigger: 'blur'}
          ],
          endTime: [
            {required: true, message: '结束时间不能为空', trigger: 'blur'}
          ],
          amount:[
            {validator:validateNumber,trigger: 'blur'}
          ],
          numberWork:[

            {validator:validateNumber,trigger: 'blur'}
          ],
          numberWorkh:[
            {validator:validateNumber,trigger: 'blur'}
          ],
          price:[
            {validator:validateNumber,trigger: 'blur'}
          ],priceh:[{validator:validateNumber,trigger: 'blur'}]
          ,customers:[
            {required: true, message: '客户不能为空', trigger: 'blur'}
          ]
        },
        //表单验证规则
        rules: {
          type: [{
            required: true,
            trigger: 'blur',
            message: '请输入类型',
          }],
          price: [{validator:validateNumber,trigger: 'blur'}],
          num: [{validator:validateNumber,trigger: 'blur'}],
          startDate: [{
            required: true,
            trigger: 'blur',
            message: '请输入开始日期',
          }],
          endDate: [{
            required: true,
            trigger: 'blur',
            message: '请输入结束日期',
          }],
        },
        ysjerules: {
          qcyeje: [{
            validator:validateNumber,
            trigger: 'blur'
          }],
          bqkpje: [{
            validator:validateNumber,
            trigger: 'blur'
          }],
          bqskje: [{
            required: true,
            trigger: 'blur',
            message: '请输入本期收款金额'
          },{
            validator:validateNumber,
            trigger: 'blur'
          }],
          qmqkje: [{
            validator:validateNumber,
            trigger: 'blur'
          }],
          skrq: [{
            required: true,
            trigger: 'blur',
            message: '请选择收款日期',
          }]
        },
        qtjerules: {
          je: [{
            validator:validateNumber,
            trigger: 'blur',
            required: true,
            message: '请输入金额!',
          }],
          rq: [{
            required: true,
            trigger: 'blur',
            message: '请选择日期',
          }],
          bz: [{
            required: false,
            trigger: 'blur',
            message: '请输入备注',
          }]
        },
        pickerOptions:{
          shortcuts: [{
            text: '合同开始日期',
             onClick : (picker) => {
              if( !this.dataForm.startTime) {
                this.$message.warning("请选择合同开始日期")
                return;
              }
               const start = this.dataForm.startTime;
               picker.$emit('pick', start);
            }
          }],
          disabledDate:(time) => {

            return time.getTime() < this.startTime || (time.getTime() > this.endTime && this.endTime !=0);
          },
        },
        pickerOptions1:{
          shortcuts: [{
            text: '合同结束日期',
            onClick : (picker) => {
              if( !this.dataForm.endTime) {
                this.$message.warning("请选择合同结束日期")
                return;
              }
              const start = this.dataForm.endTime;
              picker.$emit('pick', start);
            }
          }],
          disabledDate:(time) => {
            return (time.getTime() < this.startTime)|| (time.getTime() > this.endTime && this.endTime !=0);
          },
        },
        pickerOptions2:{
          disabledDate:(time) => {
            return this.endTime === 0?false: time.getTime() > this.endTime;
          },
        },
        pickerOptions3:{
          disabledDate:(time) => {
            return this.startTime === 0?false: time.getTime() < this.startTime;
          },
        }
      }
    },
    created(){
      this.getDepts()
    },
    methods: {
      init (id) {
        this.dataForm.id = id
        this.visible = true
        this.fileData = []
        this.fileList = []
        this.fileName = []
        this.fileData2 = []
        this.fileList2 = []
        this.fileName2 = []
        this.form.datils =  [];
        this.ysjeform.ysjedatils=[];
        this.qtjeform.jedatils=[];
        this.dataForm.workConfigs=[];
        this.dataForm.receiveAmounts=[];
        this.$nextTick(() => {
          this.getCustomers()
          this.$refs['dataForm'].resetFields()
          this.$refs.upload.clearFiles()
          this.$refs.upload2.clearFiles()
          this.fileList=[]
          this.fileList2=[]
          if(this.dataForm.id) {
            this.$http({
              url: '/bjba/contract/info/'+this.dataForm.id,
              method: 'get'
            }).then(({data}) => {
              let Data = data.data.data
              this.fileData  = data.data.attach.htfj
              this.fileData2  = data.data.attach.htbcfj
              this.fileReset()
              this.fileReset2()
              this.dataForm.numberWork = Data.numberWork
              this.dataForm.numberWorkh = Data.numberWorkh
              this.dataForm.customers = Data.customers
              this.dataForm.startTime = Data.startTime
              this.dataForm.endTime = Data.endTime
              this.dataForm.attachBc = Data.attachBc
              this.dataForm.price = Data.price
              this.dataForm.priceh = Data.priceh
              this.dataForm.workPlace= Data.workPlace
              this.dataForm.remaek = Data.remaek
              this.dataForm.attach = Data.attach
              this.dataForm.amount = Data.amount
              this.dataForm.otherAmount = Data.otherAmount
              this.dataForm.receiveAmount = Data.receiveAmount
              this.dataForm.ssdd = Data.ssdd
              this.dataForm.htwblx = Data.htwblx
              this.dataForm.cooperationStatus = Data.cooperationStatus
              if (Data.workConfigs) {
                this.form.datils = Data.workConfigs
              }
              if (Data.receiveAmounts) {
                this.ysjeform.ysjedatils = Data.receiveAmounts
              }
              if (Data.qtjes) {
                this.qtjeform.jedatils = Data.qtjes
              }
            })
          }
        })

      },
      init2 (id) {
        this.$refs.upload.clearFiles()
        this.fileData = []
        this.fileList = []
        this.fileName = []
        this.$refs.upload2.clearFiles()
        this.fileData2 = []
        this.fileList2 = []
        this.fileName2 = []
        this.$nextTick(() => {
          this.fileList=[]
          this.fileList2=[]
          this.$http({
              url: '/bjba/contract/info/'+id,
              method: 'get'
            }).then(({data}) => {
              this.fileData  = data.data.attach.htfj
              this.fileData2  = data.data.attach.htbcfj
              this.fileReset()
              this.fileReset2()
            })
        })

      },
      getDepts() {
        let that = this;
        this.$request
                .get("/bjba/kqtj/getFirstMentForUser", {
                  params: {
                    userid: this.$store.getters.username,
                  },
                })
                .then((res) => {
                  
                  that.depts = res.data;
                });
      },
      //删除操作
      click_delete(item,index) {
        this.$confirm("确定删除该条数据吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
                .then(() => {
                  //模拟删除一条数据
                  this.form.datils.splice(index,1);
                })
                .catch(() => {});
      },
      //删除已收金额
      click_delete_ysje(item,index) {
        this.$confirm("确定删除该条数据吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //模拟删除一条数据
            this.ysjeform.ysjedatils.splice(index,1);
          })
          .catch(() => {});
      },
      //删除已收金额
      click_delete_qtje(item,index) {
        this.$confirm("确定删除该条数据吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //模拟删除一条数据
            this.qtjeform.jedatils.splice(index,1);
          })
          .catch(() => {});
      },
      //新增操作
      click_add(item,index) {
        // if( !this.validateField('form',index) ) return;
        //模拟新增一条数据
        var itemClone={
          type:'',
          price: '',
          time: '',
          num: '',
        }
        this.form.datils.push(itemClone);
        // this.resetField('form',index);
      },
      //新增已收金额
      click_add_ysje(item,index) {
        //模拟新增一条数据
        var itemClone={
          qcyeje: '',
          bqkpje: '',
          bqskje: '',
          qmqkje: '',
          skrq: ''
        }
        this.ysjeform.ysjedatils.push(itemClone)
      },
       //新增其他金额
       click_add_qtje(item,index) {
        //模拟新增一条数据
        var itemClone={
          je:'',
          rq:'',
          bz:'',
        }
        this.qtjeform.jedatils.push(itemClone)
      },
      changeDate(startTime) {
        var startTime = this.getDate(startTime);
        for (var i =0;i<this.form.datils.length;i++) {
          if(this.form.datils[i].startDate ) {
            if( startTime.getTime() > this.getDate(this.form.datils[i].startDate).getTime()) {

              this.$set(this.form.datils[i],'startDate','')

            }
          }
        }
      },
      changeDate1(startTime) {
        var startTime = this.getDate(startTime);
        for (var i =0;i<this.form.datils.length;i++) {
          if(this.form.datils[i].endDate) {
            if( startTime.getTime() < this.getDate(this.form.datils[i].endDate).getTime()) {

              this.$set(this.form.datils[i],'endDate','')

            }
          }
        }
      },
      getDate(date) {
        date = date.substring(0,19);
        date = date.replace(/-/g,'/');
        var timestamp = new Date(date)
        return timestamp
      },
      beforeAvatarUpload(file){
        return  true;
      },
      handleChange(file1,fileList1) {
        this.fileList = []
        this.fileList.length = 0
      for (let i = 0; i < fileList1.length; i++) {
        this.fileList.push(fileList1[i].raw)
      }
      this.fileReset()
    },
    handleChange2(file1,fileList) {
        this.fileList2 = []
        this.fileList2.length = 0
      for (let i = 0; i < fileList.length; i++) {
        this.fileList2.push(fileList[i].raw)
      }
      this.fileReset2()
    },
    download(item) {
      if (item.id != undefined) {
        this.axios
          .get('sjdc/jwjxsxfjb/download/' + item.id, { responseType: 'blob' })
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.style.display = 'none'
            downloadElement.href = href
            downloadElement.download = item.name // 下载后文件名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    modeUpload(item) {
      this.mode = item.file
    },
    imports(file, type, id) {
      let data = new FormData()
      for (let i = 0; i < file.length; i++) {
        data.append('file', file[i].raw)
      }
      data.append('id', id)
      data.append('type', type)
      return this.axios.post('bjba/file/imports', data, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
        if (response.data) {
          this.openMessage(0, '附件上传成功')
        } else {
          this.$message.error('附件上传失败')
        }
      })
    },
    deleteFile(item) {
      if (item.id != undefined) {
        this.deleteFileData(item)
      } else {
        this.fileList.some((file, i) => {
          if (file.uid == item.uid) {
            this.fileList.splice(i, 1)
            return true
          }
        })
        const index = this.$refs.upload.uploadFiles.findIndex((e) => e.uid === item.uid)
        this.$refs.upload.uploadFiles.splice(index, 1)
        this.openMessage(0, '删除成功')
        this.fileReset()
      }
    },
    deleteFile2(item) {
      if (item.id != undefined) {
        this.deleteFileData(item)
      } else {
        this.fileList2.some((file, i) => {
          if (file.uid == item.uid) {
            this.fileList2.splice(i, 1)
            return true
          }
        })
        const index = this.$refs.upload2.uploadFiles.findIndex((e) => e.uid === item.uid)
        this.$refs.upload2.uploadFiles.splice(index, 1)
        this.openMessage(0, '删除成功')
        this.fileReset2()
      }
    },
    deleteFileData(item) {
      this.axios({
        url: 'bjba/file/fileDelete',
        method: 'GET',
        params: Object.assign({ id: item.id })
      })
        .then((res) => {
          this.openMessage(res.data.status, res.data.message)
          if(res.data.status == 0){
            this.init2(this.dataForm.id)
          }
        })
        .catch((error) => {
          this.$message.error('操作失败!')
          console.log(error)
        })
    },
    fileReset() {
      this.fileName.splice(0)
      if (this.fileData != undefined && this.fileData.length > 0) {
        this.fileData.forEach((item) => {
          this.fileName.push({
            id: item.id,
            name: item.name
          })
        })
      }
      if (this.fileList != undefined && this.fileList.length > 0) {
        this.fileList.forEach((item) => {
          this.fileName.push(item)
        })
      }
    },
    fileReset2() {
      this.fileName2.splice(0)
      if (this.fileData2 != undefined && this.fileData2.length > 0) {
        this.fileData2.forEach((item) => {
          this.fileName2.push({
            id: item.id,
            name: item.name
          })
        })
      }
      if (this.fileList2 != undefined && this.fileList2.length > 0) {
        this.fileList2.forEach((item) => {
          this.fileName2.push(item)
        })
      }
    },
    openMessage(status, message) {
      this.$notify({
        title: status == 0 ? '操作成功' : '操作失败',
        message: message,
        type: status == 0 ? 'success' : 'error'
      })
    },
      httpRequest(data){
        let _that=this;
        let rd = new FileReader(); // 创建文件读取对象
        let file = data.file;
        this.fileList.push(file)
        let formData = new FormData();
        formData.append('file', file);
        this.$request({
          method: 'post',
          url: '/bjba/customer/uploadContract',
          data:formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(res => {
          if (res.data.code == 200) {
            this.dataForm.attach = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      httpRequest2(data){
        let _that=this;
        let rd = new FileReader(); // 创建文件读取对象
        let file = data.file;
        this.fileList2.push(file)
        let formData = new FormData();
        formData.append('file', file);
        this.$request({
          method: 'post',
          url: '/bjba/customer/uploadContract',
          data:formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(res => {
          if (res.data.code == 200) {
            this.dataForm.attachBc = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      handleRemove(file, fileList) {
        this.dataForm.attach ='';
        this.fileList = []
      },
      handleRemove2(file, fileList) {
        this.dataForm.attachBc ='';
        this.fileList2 = []
      },
      getCustomers() {
        this.$http({
          url: '/bjba/customer/findAll/',
          method: 'get'
        }).then(({data}) => {
          this.customerList = data.data
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid,object) => {
          if (!valid) {
            var me;
            for (var message in object) {
              me = object[message];
              break;
            }
            this.$message({
              message: me[0].message,
              type: "error",
              center: true,
              showClose: true,
            });
            return;
          }
          if (valid) {

            this.$refs['form'].validate((valid2,object) => {
              if (!valid2) {
                var me;
                for (var message in object) {
                  me = object[message];
                  break;
                }
                this.$message({
                  message: me[0].message,
                  type: "error",
                  center: true,
                  showClose: true,
                });
                return false;
              }
              if(valid2) {

                this.$refs['ysjeform'].validate((valid3,object) => {
                  if (!valid3) {
                    var me;
                    for (var message in object) {
                      me = object[message];
                      break;
                    }
                    this.$message({
                      message: me[0].message,
                      type: "error",
                      center: true,
                      showClose: true,
                    });
                    return false;
                  }
                  if (valid3) {
                    console.log(!this.form.datils)
                    if(!this.form.datils || this.form.datils.length<=0) {
                      this.$message.error("请输入人员配置")
                      return;
                    }
                    var data = JSON.parse(JSON.stringify(this.form.datils));
                    var ysjedata = JSON.parse(JSON.stringify(this.ysjeform.ysjedatils));
                    this.dataForm.workConfigs = data;
                    this.dataForm.receiveAmounts = ysjedata;
                    var qtje = JSON.parse(JSON.stringify(this.qtjeform.jedatils));
                    this.dataForm.qtjes = qtje;
                    this.$http({
                      url: `/bjba/contract/save`,
                      method: 'post',
                      data: this.dataForm
                    }).then(({data}) => {
                      if (data && data.code === 200) {
                        let file = this.$refs.upload.uploadFiles
                        if (file.length > 0) {
        this.imports(file, 'htfj', data.data)
      }
      let file2 = this.$refs.upload2.uploadFiles
                        if (file2.length > 0) {
        this.imports(file2, 'htbcfj', data.data)
      }
                        this.$message({
                          message: '操作成功',
                          type: 'success',
                          duration: 1500
                        })
                        this.visible = false
                        this.$emit('refreshDataList')
                      } else if(data && data.code === 500) {
                        this.$message({
                          message: data.message,
                          type: 'error',
                          duration: 1500
                        })
                      }
                    })
                  }
                })
              }
            })

          }
        })
      }
    },
    computed: {
      startTime () {
        if(this.dataForm.startTime) {
          return this.getDate(this.dataForm.startTime).getTime()
        } else return 0;
      },
      endTime () {
        if(this.dataForm.endTime) {
          return this.getDate(this.dataForm.endTime).getTime()
        } else return 0;
      }
    },
  }
</script>
<style scoped>
 ::v-deep .el-scrollbar__wrap{
  overflow-x: hidden;
}
</style>
